<template>
    <div>
        <div v-if="orderMetaPopulated">
            <div class="orderBoxApp">
                <div class="prodBox" >
                    <product-config v-if="products.length" :product="products[0]" :main="true" :preConfig="product.c_part.replace(product.config_prefix,'')"></product-config>
                </div>
            </div>
            <router-link to="/" class="btn btn-sm btn-default marginright10">Cancel</router-link>
            <button class="btn btn-sm btn-primary" @click="updateCart">Update</button>

            <div class="bg-info padding15 margintop15 marginbottom30" v-html="editingNotesMsg"></div><!-- dynamic message: Editing Notes -->
        </div>
        <div v-else>
            <img src='/layouts/main/styles/images/spinner.gif' />
        </div>
    </div>
</template>

<script>
    import { ref, computed, onMounted } from '@vue/composition-api'
    import router from "../router"
    import useAlerts from '../../shared/composables/useAlerts'
    import useCMS from "../../shared/composables/useCMS"
    import useProductInfo from '../../order-info/composables/useProductInfo'
    import useProductConfig from '../../order-info/composables/useProductConfig'
    import useCart from "../composables/useCart"
    import useCheckout from "../composables/useCheckout"
    import productConfig from '../../order-info/components/productConfig'

    export default {
        name: 'EditCartItem',
        props: {
            cartItemIndex: Number
        },
        components: {
            productConfig
        },
        setup: function(props){
            const { getProductInfo, products, getOrderMetaData, orderMeta } = useProductInfo();
            const { cart, getCart } = useCart();
            const { updateCartConfig } = useProductConfig();
            const { addAlert } = useAlerts();
            const { getDynamicMessage } = useCMS();
            const { pricing, clearTaxAndShipping } = useCheckout();

            const orderMetaPopulated = computed(() => Object.keys(orderMeta.value).length);
            const product = computed(() => cart.value.itemList[props.cartItemIndex].products[0]);

            onMounted(() => {
                getProductInfo(product.value.id, product.value.model, 'main');
                getOrderMetaData();
            })

            const updateCart = () => {
                updateCartConfig(product.value).then(
                    (response) => {
                        if (response.data.status == 500) {
                            //Possibly do something on error. The UI should update for required fields automatically, but possibly show error message.
                        } else if (response.data.status == 418) {
                            //nothing changed so lets just send them back to main cart page
                            router.push('/');
                        } else {
                            //fetch new data with updated config
                            getCart();
                            pricing.value = response.data.cart.pricing;
                            clearTaxAndShipping();
                            //redirects to cart page.
                            router.push('/');
                        }
                    }
                ).catch((error) => {
                    addAlert('An error occurred updating item configuration.', 'alert-danger', 7000);
                    console.log(error);
                });
            }

            const editingNotesMsg = ref('');
            getDynamicMessage(19).then((resp) => {
                if(resp.status == 200) {
                    editingNotesMsg.value = resp.data;
                }
            }).catch((error) => {
                console.log(error);
            });

            return {
                getProductInfo,
                product,
                products,
                getOrderMetaData,
                cart,
                updateCartConfig,
                orderMetaPopulated,
                orderMeta,
                getCart,
                updateCart,
                editingNotesMsg
            }
        }
    }
</script>
